<plotly-plot
  [config]="config"
  [data]="graph.data"
  [layout]="graph.layout"
  [style]="{ position: 'relative', width: '100%', height: '83vh' }"
  [useResizeHandler]="true"
>
</plotly-plot>
